import { Plugin, ButtonView } from 'ckeditor5'

import ContainerMediaGalery from 'src/container/image-gallery'

import { track } from '@amplitude/analytics-browser'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import {
  imageGalleryIcon,
  imageGalleryIconAdd,
  imageGalleryAiIcon,
} from './svg'
const handleAddImage = (dispatch, editor, type) => {
  track('media_gallery_in_editor_clicked')

  /**
   *
   * @param {} items
   */

  const setImageURL = () => {}

  const checkIfInsideSimpleBox = (selection, editor) => {
    const position = selection.getFirstPosition()
    if (!position) return false

    // Get all ancestors of the current position
    const ancestors = position.getAncestors()

    // Check if any ancestor is a simple box
    return ancestors.some(ancestor => {
      // Check if the element is a section with simple-box class
      if (ancestor.name === 'simpleBox') {
        const classes = editor.model.schema.getAttributeProperties(
          ancestor,
          'class',
        )
        return classes
      }
      return false
    })
  }
  const onOk = item => {
    const itemUrl = item[0].url

    if (editor) {
      const model = editor.model
      const selection = model.document.selection

      // Check if an image is selected
      const selectedElement = selection.getSelectedElement()
      let currentAlt = ''
      if (selectedElement !== null) {
        currentAlt = selectedElement.getAttribute('alt') || ''
      }
      var sampleHtml
      const isInsideSimpleBox = checkIfInsideSimpleBox(selection, editor)
      if (isInsideSimpleBox === true) {
        sampleHtml = `<div class="img-wrapper"><img src="${itemUrl}"  alt="${currentAlt}"/></div>`
      } else {
        sampleHtml = `
          <div class="simple-box-wrapper"> 
            <div class="simple-box">
              <div class="column">
                <div class="img-wrapper"><img src="${itemUrl}"  alt="${currentAlt}"/></div>
              </div>
            </div>
          </div>`
      }

      const viewFragment = editor.data.processor.toView(sampleHtml)
      const modelFragment = editor.data.toModel(viewFragment)

      editor.model.insertContent(modelFragment)
    }

    dispatch(messageBoxHideAction())
  }

  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        buttons: [],
        title: `
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
            "
          >
         
          <Icon
            icon="ic:round-add-a-photo"
            color="#00AB55"
            width="24"
            height="24"
          />
          <Typography
            style="
              margin-left: 8;
              color: #002E47;
              fontWeight: 600;
              fontSize: 16;
            "
          >
            Media Gallery
          </Typography>
        </div>`,
        component: (
          <ContainerMediaGalery
            onOk={onOk}
            setImageURL={setImageURL}
            type={type}
          />
        ),
        draggable: true,
        maxHeight: '70vh',
      }),
    ),
  )
}
class ImageGalleryPlugin extends Plugin {
  constructor(editor) {
    super(editor)
    this.dispatch = editor.config.get('imageGalleryPlugin.dispatch')
  }
  init() {
    const editor = this.editor

    editor.ui.componentFactory.add('imageGallery', locale => {
      const view = new ButtonView(locale)
      view.set({
        label: 'Change Image',
        icon: imageGalleryIcon,
        withText: true,
        tooltip: true,
        class: 'change-image',
      })

      view.on('execute', () => {
        handleAddImage(this.dispatch, this.editor)
        editor.execute('openImageGallery')
      })

      return view
    })

    editor.ui.componentFactory.add('imageGalleryAi', locale => {
      const view = new ButtonView(locale)
      view.set({
        label: 'Generate Image',
        icon: imageGalleryAiIcon,
        tooltip: true,
        class: 'ai-change-image',
      })

      const type = 'ai'

      view.on('execute', () => {
        handleAddImage(this.dispatch, this.editor, type)
        editor.execute('openImageGallery')
      })

      return view
    })

    editor.ui.componentFactory.add('imageGalleryAdd', locale => {
      const view = new ButtonView(locale)
      view.set({
        label: 'Insert Image',
        icon: imageGalleryIconAdd,
        tooltip: true,
      })

      view.on('execute', () => {
        handleAddImage(this.dispatch, this.editor)
        editor.execute('openImageGallery')
      })

      return view
    })

    editor.commands.add('openImageGallery', {
      execute: () => {
        if (editor.config.get('imageGalleryHandler')) {
          editor.config.get('imageGalleryHandler')()
        }
      },
    })
  }
}

export default ImageGalleryPlugin
